const Navbar = () => {
  return (
    <nav className="bg-dark-gray">
      <div className="p-6 lg:px-8 flex justify-between items-end">
        <a href="/">
          <img
            className="w-[170px] h-[54px]"
            src="/logo.svg"
            alt="Loop Switching"
          />
        </a>
        <a href="/">
          <img
            className="h-[48px] w-auto hidden md:block"
            src="/switch-and-save-logo.svg"
            alt="Loop Switch and Save"
          />
          <img
            className="h-[48px] w-auto md:hidden"
            src="/switch-and-save-logo-mobile.svg"
            alt="Loop Switch and Save"
          />
        </a>
        <span className="hidden lg:block w-[170px]"></span>
      </div>
    </nav>
  );
};

export default Navbar;
